import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import * as Rox from "rox-browser";

interface DiscountChargeableWeight {
  productType: string;
  volumeWeight: number | string;
  shipmentType?: string;
}

export const isEligibleForMaxVolumeWeightDiscount = (
  params: DiscountChargeableWeight
): boolean => {
  Rox.setCustomStringProperty("data product type", () => params.productType);

  if (params.shipmentType) {
    const isShipmentCodOrTkp = new RegExp(/^ARA|^ARB|^TKP/).test(
      params.shipmentType
    );

    Rox.setCustomStringProperty("data shipment type", () =>
      (params.shipmentType as string).slice(0, isShipmentCodOrTkp ? 3 : 2)
    );
  }

  if (!params.volumeWeight) return false;

  const volumeWeight = Number(String(params.volumeWeight)?.replace(",", "."));
  const configValue = FlagsMedusa.config_max_volume_weight.getValue();

  return !!configValue && volumeWeight <= configValue;
};
